<template>
  <div>
    <titulo-turmas />

    <filtro @filtrar="filtrar" @limparFiltro="limparTabela" />

    <div>
      <b-row class="justify-content-end">
        <b-col cols="12" md="auto">
          <b-button
            variant="info"
            class="my-3 mb-md-3 w-100"
            @click="cadastrarNovaTurma"
            :disabled="btnCadastrar"
            v-if="podeCadastrar"
          >
            {{ $t('ACADEMICO.TURMA_CADASTRAR') }}
          </b-button>
        </b-col>
      </b-row>
      <tabela-turmas
        :turmas="resultadoBusca"
        @editar="cadastrarNovaTurma"
        @excluir="confirmarExclusao"
        @alterar-ordenacao="novaOrdenacao"
      />
      <paginacao
        v-model="paginacao"
        :total="paginacao.total"
        @input="obterTurmaPorCursoGrupo"
      />
    </div>

    <modal-turma
      :form="modais.turmaDados"
      :exibir="modais.turma"
      :filtro="filtro"
      @atualiza-tabela="obterTurmaPorCursoGrupo"
      @nova-turma="cadastrarTurma"
      @fechar="fecharModalTurma"
    />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import rotas from '@/common/utils/rotas';
import Permissoes from '@/components/mixins/permissoes';

// Services:
import TurmasService from '@/common/services/academico/turma.service.js';

// Components:
import Filtro from '@/views/academico/turmas/components/Filtro.vue';
import TabelaTurmas from '@/views/academico/turmas/components/TabelaTurmas.vue';
import ModalTurma from '@/views/academico/turmas/components/ModalTurma.vue';
import TituloTurmas from '@/views/academico/cej/estrutura/turmas/components/TitulosTurmas';
import Paginacao from '@/components/paginacao/Paginacao';
export default {
  mixins: [Permissoes],
  components: {
    Filtro,
    TituloTurmas,
    TabelaTurmas,
    ModalTurma,
    Paginacao
  },
  data() {
    return {
      filtro: {},
      resultadoBusca: [],
      modais: {
        turma: false,
        turmaDados: {
          disciplinas: []
        },
      },
      btnCadastrar: true,
      campoOrdenado: null,
      ordem: false,
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
    };
  },
  mounted() {
    let filtro = this.$route.params?.filtro;
    if (filtro) this.filtro = filtro; 
  },
  methods: {
    // FUNÇÕES FILTRO:
    cadastrarTurma() {
      this.modais.turmaDados = {
        disciplinas: [],
      }
    },
    cadastrarNovaTurma(key, item) {
      if (item) {
        this.$router.push({
          name: 'editar-turma',
          params: { 
            id: item.id,
            filtro: this.filtro 
          },
        });
      }
      else {
        this.$router.push({
          name: 'nova-turma',
          params: {
            filtro: this.filtro 
          },
        });
      }
    },
    obterTurmaPorCursoGrupo() {
      this.$store.dispatch(START_LOADING);
      TurmasService.obterTurmaPorCursoGrupo(this.paginacao, this.filtro, this.campoOrdenado, this.ordem)
        .then(({ data }) => {
          this.resultadoBusca = data.itens;
          this.btnCadastrar = false;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    filtrar(filtroUtilizado) {
      this.filtro = filtroUtilizado
      this.obterTurmaPorCursoGrupo()
    },
    limparTabela() {
      this.btnCadastrar = true;
      this.resultadoBusca = [];
    },
    fecharModalTurma() {
      this.modais.turma = false;
      this.modais.turmaDados = {
        disciplinas: [],
      }
    },
    // FUNÇÕES CRUD
    async confirmarExclusao(item) {
      let itemExclusao = this.resultadoBusca.filter(
        (itemBusca) => itemBusca.id == item
      );
      const respostaExclusao = await mensagem.confirmacao(
        this.$t('ACADEMICO.TURMA_CONFIRMAR_EXCLUSAO_TITULO', {
          item: itemExclusao[0]?.descricao ? itemExclusao[0].descricao : '',
        }),
        this.$t('ACADEMICO.TURMA_CONFIRMAR_EXCLUSAO_DESCRICAO')
      );
      if (respostaExclusao.isConfirmed) {
        this.excluir(item);
      }
    },
    // excluir(turmaId) {
    //   this.$store.dispatch(START_LOADING);
    //   TurmasService.excluir(turmaId)
    //     .then(() => {
    //       mensagem.sucesso(
    //         this.$t('GERAL.SUCESSO'),
    //         this.$t('ACADEMICO.TURMA_EXCLUIDA')
    //       );
    //       this.obterTurmaPorCursoGrupo();
    //     })
    //     .catch((err) => {
    //       mensagem.showErrors(err);
    //     })
    //     .finally(() => {
    //       this.$store.dispatch(STOP_LOADING);
    //     });
    // },
      
    excluir(turmaId) {

      console.log('filtro na exclusao', this.filtro)

      let anoLetivoId = this.filtro?.anoLetivoId || this.filtro?.ano_letivo_id || this.filtro?.anoId || null

      this.$store.dispatch(START_LOADING)
      TurmasService.excluir(turmaId, anoLetivoId)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), this.$t('ACADEMICO.TURMA_EXCLUIDA'))
          this.obterTurmaPorCursoGrupo()
        })
        .catch((err) => {
          mensagem.showErrors(err)
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING)
        })
    },
    // FUNÇÕES AUXILIARES:
    irPara(rota, id) {
      rotas.irPara(rota, id);
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = ordem;
      this.obterTurmaPorCursoGrupo(); 
    },
  },
};
</script>
